import styled, { css } from 'styled-components';

import { type CardSizes } from '@pkg/components';

import { HoverUnderline } from '@app/pages/NFTDetailView/components/MainStage/components/NFTInfo/styles';

export const Wrapper = styled.div<{ $cardSize?: CardSizes }>`
    width: 100%;
    padding: 8px 12px;

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                padding: 6px 8px 3px 8px;
            `;
        }
    }}
`;

export const Inside = styled.div<{ $setHeight?: boolean; $cardSize?: CardSizes }>`
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;

    ${({ $setHeight }) => {
        if ($setHeight) {
            return css`
                height: 36px;
            `;
        }
    }}

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                gap: 6px;
            `;
        }
    }}
`;

export const Thumbnail = styled.div<{ $image?: string | null }>`
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;

    ${({ $image }) =>
        $image &&
        css`
            background-image: url(${$image});
        `}
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 1px;
`;

export const CollectionName = styled.div<{ $cardSize?: CardSizes }>`
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    position: relative;

    padding-bottom: 2px;

    a {
        position: relative;
    }

    ${HoverUnderline} {
        top: unset;
        bottom: 0;
    }

    &:hover {
        ${HoverUnderline} {
            transform: scaleX(1);
            transform-origin: 0 0;
        }
    }

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                font-size: 14px;
            `;
        }
    }}
`;

export const NftName = styled.div<{ $cardSize?: CardSizes }>`
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    transition: color 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
        color: rgba(255, 255, 255, 0.7);
    }

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                font-size: 12px;
            `;
        }
    }}
`;

export const ThumbnailSkeleton = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
`;
